import { gql } from '@apollo/client';

const WarrantyInfoShared = gql`
  fragment WarrantyInfoShared on Warranty {
    id
    account {
      id
      accountNumber
    }
    adminUser {
      id
      firstName
      lastName
    }
    arch
    code
    createdAt
    haveCurrentSet
    hexCode
    howOftenWear
    lowerArchFit
    message
    order {
      id
      hexCode
    }
    partnerLocation {
      id
      name
    }
    partnerOrganization {
      id
      name
    }
    partnerUser {
      id
      firstName
      lastName
    }
    patient {
      id
      firstName
      lastName
    }
    permittedStateActions
    productionOrder {
      id
      hexCode
      manufacturer {
        id
        name
      }
    }
    productionOrders {
      id
      hexCode
      manufacturer {
        id
        name
      }
      productionOrderItems {
        id
        trackingNumber
        shippingCarrier {
          id
          name
        }
        trackingUrl
      }
    }
    scanSinceLast
    scanStatus
    source
    state
    updatedAt
    upperArchFit
    user {
      id
      firstName
      lastName
      email
      phone
    }
    userIssue
    warrantyImages {
      id
      fileUrl
      originalFilename
      fileType
      warrantyId
    }
    warrantyErrors {
      id
      name
      description
    }
    warrantyIssues {
      id
      name
      description
    }
    warrantyIssuesUpper {
      id
      name
      description
    }
    warrantyIssuesLower {
      id
      name
      description
    }
    warrantyNotes {
      id
      message
      createdAt
    }
    whereToShip
  }
`;

export default WarrantyInfoShared;
